/**
 * Utility function to handle error responses from the backend API
 * Handles both string and object error details from FastAPI
 * @param {Object} errorData - The error response data from the API
 * @param {string} defaultMessage - Default error message if no detail is provided
 * @returns {string} - Formatted error message
 */
export const handleApiError = (errorData, defaultMessage = 'An error occurred') => {
  if (!errorData || !errorData.detail) {
    return defaultMessage;
  }

  const detail = errorData.detail;

  // If detail is a string, return it directly
  if (typeof detail === 'string') {
    return detail;
  }

  // If detail is an object with a msg property (Pydantic validation error)
  if (typeof detail === 'object' && detail.msg) {
    return detail.msg;
  }

  // If detail is an array of validation errors
  if (Array.isArray(detail)) {
    return detail.map(err => err.msg || 'Validation error').join(', ');
  }

  // Fallback to default message
  return defaultMessage;
};
